import { safeParseJson } from '../utils/safeParseJson';

const KEY = 'dg_communicate_archive_v1';
const MAX = 30;

export type CommunicateArchiveKind = 'thread' | 'sheet' | 'email' | 'sms';

export type CommunicateArchiveEntry = {
  id: string;
  at: number;
  kind: CommunicateArchiveKind;
  title: string;
  detail?: string;
};

function read(): CommunicateArchiveEntry[] {
  try {
    const raw = typeof window !== 'undefined' ? window.localStorage.getItem(KEY) : null;
    const parsed = safeParseJson<unknown>(raw, null);
    return Array.isArray(parsed) ? (parsed as CommunicateArchiveEntry[]) : [];
  } catch {
    return [];
  }
}

export function getCommunicateArchive(): CommunicateArchiveEntry[] {
  return read()
    .filter((e) => e && typeof e.id === 'string' && typeof e.at === 'number')
    .sort((a, b) => b.at - a.at);
}

export function clearCommunicateArchive(): void {
  try {
    if (typeof window !== 'undefined') window.localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function appendCommunicateArchive(
  entry: Omit<CommunicateArchiveEntry, 'id' | 'at'> & { at?: number }
): CommunicateArchiveEntry[] {
  const id = `a_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  const at = entry.at ?? Date.now();
  const next: CommunicateArchiveEntry[] = [
    {
      id,
      at,
      kind: entry.kind,
      title: entry.title.trim() || '—',
      detail: entry.detail?.trim() || undefined,
    },
    ...read(),
  ].slice(0, MAX);
  try {
    window.localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* ignore quota */
  }
  return next;
}
